import $ from 'jquery';
import throttle from 'lodash/throttle';

/** Constant media query states. */
export const MOBILE = 'MOBILE';
export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
export const TABLET = 'TABLET';
export const TABLET_MEDIA_QUERY = '(min-width: 768px) and (max-width: 1199px)';
export const DESKTOP = 'DESKTOP';
export const DESKTOP_MEDIA_QUERY = '(min-width: 1200px)';

/** Local reference to device type, allows the value to be read-only. */
let deviceType = '';

/** Singleton instance. */
let instance;

/** Check the existing device state, singleton. */
class MobileChecker {
  static get instance() {
    if (instance === undefined) {
      instance = new MobileChecker();
    }
    return instance;
  }
  constructor() {
    $(window).on('resize', throttle(this.checkDeviceSize, 100));
    this.checkDeviceSize();
  }
  /** Get device type. */
  get deviceType() { // eslint-disable-line class-methods-use-this
    return deviceType;
  }
  /** Set device type based on media queries. */
  checkDeviceSize() {
    if (Modernizr.mq(MOBILE_MEDIA_QUERY)) {
      deviceType = MOBILE;
    }

    if (Modernizr.mq(TABLET_MEDIA_QUERY)) {
      deviceType = TABLET;
    }

    if (Modernizr.mq(DESKTOP_MEDIA_QUERY)) {
      deviceType = DESKTOP;
    }

    return this.deviceType;
  }
  /** Check if mobile media query is true. */
  isMobile() {
    return this.deviceType === MOBILE;
  }
  /** Check if tablet media query is true. */
  isTablet() {
    return this.deviceType === TABLET;
  }
  /** Check if desktop media query is true. */
  isDesktop() {
    return this.deviceType === DESKTOP;
  }
}

export default MobileChecker;



// WEBPACK FOOTER //
// ./js/components/init-check-device.js